import { Component, OnInit } from '@angular/core';
import { AdminService } from './admin.service';

import { map } from 'rxjs/operators';

@Component({
  selector : 'app-admin',
  templateUrl : './admin.component.html',
  styleUrls : ['./admin.component.css']
})
export class AdminComponent implements OnInit{
   constructor( private adminService : AdminService ){}
   checkOutDataDetails = [];
   cartDataFinal = [];
   datashow = [];
   loadder = false;
    ngOnInit(){
      this.checkOutData();
    }

    checkOutData(){
        this.adminService.getData()
        .pipe(
          map(responseData =>{
             const postArray = [];
             for(const key in responseData){
               if(responseData.hasOwnProperty(key)){
                 postArray.push({ ...responseData[key], id:key});
               }
             }
             return postArray;
          })
        )
        .subscribe(res=>{
           // this.datashow.push(res);
         // console.log('value', res);
          this.checkOutDataDetails = [];
          this.datashow = res;
          for(let i = 0 ; i<this.datashow.length; i++){
            this.checkOutDataDetails.push(this.datashow[i][0]);
           console.log('check out data',this.checkOutDataDetails);
           console.log('eghr0');
           this.loadder = true;
                       //this.cartDataFinal.push(this.datashow[i][0].cartData[i]);
          }

          // this.datashow = res;
          // for(let i = 0 ; i<this.datashow.length; i++){
          //   this.cartDataFinal.push(this.datashow[i][0].cartData);
          //  console.log('check out data',this.cartDataFinal);
            //this.cartDataFinal.push(this.datashow[i][0].cartData[i]);
          //}



            

        })
    }

}